import {Button, Form, Modal, Spinner} from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {IResEditUser, ListUsersNode} from '../../../graphql/types/usersTypes'
import {useEffect} from 'react'
import {EDIT_USER} from '../../../graphql/mutations/userMutations'
import {useMutation} from '@apollo/client'
import {parseId} from '../../../helpers'
import {toast} from 'react-toastify'

interface IModal {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  user: ListUsersNode
}

export const ModalEditUser: React.FC<IModal> = ({isOpen, onClose, refetch, user}) => {
  const [gqlEdit, {data, loading, error}] = useMutation<IResEditUser>(EDIT_USER)

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required('Nombres es requerido'),
      lastName: Yup.string().required('Apellidos es requerido'),
      email: Yup.string()
        .email('Correo electrónico inválido')
        .required('Correo electrónico es requerido'),
    }),
    onSubmit: (values) => {
      gqlEdit({
        variables: {
          input: {
            ...values,
            id: parseId(user.id),
          },
        },
      })
    },
  })

  useEffect(() => {
    if (!user) return
    formik.setValues({
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    if (error) toast.error(`Error: ${error}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.userUpdate.success) {
      toast.success('Usuario editado correctamente')
      onClose()
      refetch()
    } else if (data.userUpdate.errors) {
      toast.error(`Error: ${data.userUpdate.errors.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <Modal show={isOpen} onHide={onClose} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Editar Usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit} id='formId'>
          <Form.Group controlId='firstName'>
            <Form.Label>Nombres</Form.Label>
            <Form.Control
              type='text'
              name='firstName'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstName}
              isInvalid={Boolean(formik.touched.firstName && formik.errors.firstName)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.firstName}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mt-3' controlId='lastName'>
            <Form.Label>Apellidos</Form.Label>
            <Form.Control
              type='text'
              name='lastName'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastName}
              isInvalid={Boolean(formik.touched.lastName && formik.errors.lastName)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.lastName}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mt-3' controlId='email'>
            <Form.Label>Correo electrónico</Form.Label>
            <Form.Control
              type='email'
              name='email'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              isInvalid={Boolean(formik.touched.email && formik.errors.email)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose} type='button'>
          Cancelar
        </Button>
        <Button form='formId' variant='warning' type='submit' disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-3' />}
          Editar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
